/**
 * @file 腾讯对象存储二次封装
 * @author 张海松
 * @Date 2021-04-21 15:10:05
 */
let defaultOption = {
  ChunkSize: 10485760, // 分块上传时，每片的字节数大小 10M
  SliceSize: 10485760 * 2, // 使用 uploadFiles 批量上传时，文件大小大于该数值将使用按分块上传，否则将调用简单上传
  FileParallelLimit: 1000, // 同一个实例下上传的文件并发数
  ChunkParallelLimit: 100, // 同一个上传文件的分块并发数
  defaultRegion: 'ap-chongqing', // 默认区域 重庆
  defaultBucket: 'ddbes-pan-tmp-1304188286' // 默认上传存储桶，网盘存储桶
};

/**
 * 腾讯对象存储封装 用于文件上传下载
 *
 * @class
 * @param {Function} COS 腾讯对象存储cos
 * @param {Object} option 所需参数对象
 * @param {Function} option.getAuthorization 获取上传token及存储桶bucket
 * @param {number} option.ChunkSize 分块上传时，每片的字节数大小 10M
 * @param {number} option.SliceSize 使用 uploadFiles 批量上传时，文件大小大于该数值将使用按分块上传，否则将调用简单上传
 * @param {number} option.FileParallelLimit 同一个实例下上传的文件并发数
 * @param {number} option.ChunkParallelLimit 同一个上传文件的分块并发数
 * @param {number} option.defaultRegion 上传区域
 * @param {number} option.defaultBucket 上传存储桶
 * @param {number} option.defaultBucketKey 上传存储桶key 从接口中获取存储桶
 */
function DdbesCos(option, COS) {
  if (!COS) {
    return new Error('Error:缺少参数 COS');
  }
  this.option = Object.assign(defaultOption, option);
  const {ChunkSize, SliceSize, FileParallelLimit, ChunkParallelLimit} = this.option;
  this.uploadToken = null;
  this.cos = new COS({
    ChunkSize,
    SliceSize,
    FileParallelLimit,
    ChunkParallelLimit,
    getAuthorization: (options, callback) => { // 异步获取临时密钥
      if (this.checkTokenExpire()) {
        this.setToken(callback);
      } else {
        this.getAuthorization(() => {
          this.setToken(callback);
        });
      }
    }
  });
}

DdbesCos.prototype.getAuthorization = function(getOver) {
  const {getAuthorization, uuid} = this.option;
  getAuthorization(uuid).then((res) => {
    console.log(res)
    if (res.credentials) {
      this.uploadToken = res;
    } else if (res && res.data && res.code === 1) {
      this.uploadToken = res.data;
    }
    getOver();
  });
};

DdbesCos.prototype.on = function(action, callback) {
  this.cos.on([action], data => {
    callback(data);
  });
};

DdbesCos.prototype.setToken = function(callback) {
  console.log(this.uploadToken)
  const {credentials, expiredTime} = this.uploadToken;
  callback({
    TmpSecretId: credentials.tmpSecretId, // 临时密钥的 tmpSecretId
    TmpSecretKey: credentials.tmpSecretKey, // 临时密钥的 tmpSecretKey
    XCosSecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
    ExpiredTime: expiredTime // 临时密钥失效时间戳，是申请临时密钥时
  });
};

/**
 * 多文件同时上传
 *
 * @param {Object} option 参数描述
 * @param {...Object} option.files 要上传的文件对象数组
 * @param {Function} option.onProgress 上传进度
 * @param {Function} option.onFileFinish 每个文件上传完成后调用
 * @param {string} option.bucketKey 上传存储桶的key 从uploadToken 获取bucket
 * @param {string} option.region 上传存储桶区域
 */
DdbesCos.prototype.uploadFiles = function(option) {
  if (!this.checkTokenExpire(true)) {
    this.getAuthorization(() => {
      this.uploadFiles(option);
    });
  } else {
    let {bucket, files, onProgress, onFileFinish, bucketKey, region} = option;
    if (!bucket && bucketKey) {
      bucket = this.checkBucket(bucketKey);
    }
    const {defaultBucket, defaultRegion} = this.option;
    const uploadFiles = files.map((file) => {
      file.Bucket = bucket || defaultBucket;
      file.Region = region || defaultRegion;
      return file;
    });
    this.cos.uploadFiles({
      files: uploadFiles,
      onProgress: onProgress,
      onFileFinish: onFileFinish
    });
  }
};

/**
 * 文件分片上传
 *
 * @param {Object} option 上传文件参数
 * @param {function(Object,Object)} callback(err,data) 上传成功或失败回调,第一个参数为失败对象，第二个参数为成功对象
 * @param {=*} option.file 要上传的文件可以为 base64， blob， File对象
 * @param {Function} option.onTaskReady 上传任务准备完成
 * @param {Function} option.onProgress 文件上传进度
 * @param {string} option.bucket 上传存储桶
 * @param {string} option.bucketKey 上传存储桶的key 从uploadToken 获取bucket
 * @param {string} option.region 上传存储桶区域
 */
DdbesCos.prototype.sliceUploadFile = function(option, callback) {
  let {bucket, bucketKey, region, file, onTaskReady, onProgress, key} = option;
  if (!bucket && bucketKey) {
    bucket = this.checkBucket(bucketKey);
  }
  const {defaultBucket, defaultRegion} = this.option;
  this.cos.sliceUploadFile({
    Bucket: bucket || defaultBucket,
    Region: region || defaultRegion,
    Key: key,
    Body: file,
    onTaskReady: onTaskReady,
    onProgress: onProgress
  }, function(err, data) {
    callback(err, data);
  });
};

DdbesCos.prototype.download = function() {

};

/**
 * 获取文件静态地址
 *
 * @param {Object} option 上传文件参数
 * @param {function(Object,Object)} callback(err,data) 上传成功或失败回调,第一个参数为失败对象，第二个参数为成功对象
 * @param {string} option.bucket 上传存储桶
 * @param {string} option.bucketKey 上传存储桶的key 从uploadToken 获取bucket
 * @param {string} option.region 上传存储桶区域
 * @param {string} option.key 文件在存储桶的key
 */
DdbesCos.prototype.getDownloadUrl = function(option, callback) {
  let {bucket, bucketKey, region, key} = option;
  if (!bucket && bucketKey) {
    bucket = this.checkBucket(bucketKey);
  }
  const {defaultBucket, defaultRegion} = this.option;
  this.cos.getObjectUrl({
    Bucket: bucket || defaultBucket,
    Region: region || defaultRegion, // 存储桶所在地域，必须字段
    Key: key,
    Sign: true
  }, function(err, data) {
    callback(err, data);
  });

};

// 根据 taskId 取消上传任务。
DdbesCos.prototype.cancelTask = function(taskId) {
  this.cos.cancelTask(taskId);
};

// 根据 taskId 暂停上传任务。
DdbesCos.prototype.pauseTask = function(taskId) {
  this.cos.pauseTask(taskId);
};

// 重启上传任务
DdbesCos.prototype.restartTask = function(taskId) {
  this.cos.restartTask(taskId);
};

/**
 * 查看对象存储token是否过期
 *
 * @param {boolean} status 参数描述
 * @return {boolean} token过期或不存在返回false，否则返回true
 */
DdbesCos.prototype.checkTokenExpire = function(status = false) {
  if (!this.uploadToken) {
    return false;
  }
  const currentTime = new Date().getTime();
  const extTime = (this.uploadToken.expiredTime - 60) * 1000;
  return status || currentTime < extTime;
};

// 获取上传存储桶
DdbesCos.prototype.checkBucket = function(bucketKey) {
  return this.uploadToken[bucketKey];
};

export default DdbesCos;
